const category = {
	state: {
		channels: [],
		channelId: null,
		allCount: 0,
		classCount: []
	},
	mutations: {
		'SET_CHANNELS': (state, channels) => {
        	state.channels = channels
        },
		'SET_CHANNELID': (state, channelId) => {
        	state.channelId = channelId
        },
		'SET_ALLCOUNT': (state, allCount) => {
        	state.allCount = allCount
        },
		'SET_CLASSCOUNT': (state, classCount) => {
        	state.classCount = classCount
        }
	}
}

export default category


// WEBPACK FOOTER //
// ./src/store/modules/category.js